import { render, staticRenderFns } from "./Equipment-managements.vue?vue&type=template&id=2dc5ec97&scoped=true"
import script from "./Equipment-managements.vue?vue&type=script&lang=js"
export * from "./Equipment-managements.vue?vue&type=script&lang=js"
import style0 from "./Equipment-managements.vue?vue&type=style&index=0&id=2dc5ec97&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc5ec97",
  null
  
)

export default component.exports